import { render, staticRenderFns } from "./download50_PaotangVer.vue?vue&type=template&id=93bdb36a&scoped=true"
import script from "./download50_PaotangVer.vue?vue&type=script&lang=js"
export * from "./download50_PaotangVer.vue?vue&type=script&lang=js"
import style0 from "./download50_PaotangVer.vue?vue&type=style&index=0&id=93bdb36a&prod&scoped=true&lang=css"
import style1 from "./download50_PaotangVer.vue?vue&type=style&index=1&id=93bdb36a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93bdb36a",
  null
  
)

export default component.exports